import React, { createContext, useContext, useEffect, useState } from 'react';
import getAccessToken from 'utils/getAccessToken';

const AuthContext = createContext(null);

const apiUrl = process.env.REACT_APP_UAT_AUTH_URL;
const secretKey = process.env.REACT_APP_SECRET_KEY;
const clientId = process.env.REACT_APP_CLIENT_ID;

export const AuthProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState(localStorage.getItem('authToken'));

    const updateAuth = (token) => {
        setAuthToken(token);
        localStorage.setItem('authToken', token);
    };

    const clearAuth = () => {
        setAuthToken(null);
        localStorage.removeItem('authToken');
    };

    useEffect(() => {
        const intervalId = setInterval(checkAndUpdateToken, 60000); // Check every minute
        return () => clearInterval(intervalId); // Clean up on unmount
    }, [authToken, updateAuth]);

    async function checkAndUpdateToken() {
        if (authToken && isTokenExpired(authToken)) {
            try {
                // var refToken = localStorage.getItem('refreshToken');
                // const refreshedToken = await refreshToken(refToken, process.env.REACT_APP_CLIENT_ID, process.env.REACT_APP_UAT_AUTH_URL);

                var authData = await getAccessToken(apiUrl, clientId, secretKey);

                // Update the auth context with the new token
                updateAuth(authData.token);

                console.log("Token refreshed successfully!");
            } catch (error) {
                console.error("Token refresh failed:", error);
                // Handle refresh failure (e.g., redirect to login)
            }
        }
    }

    // Function to decode JWT and check expiry (browser-side example)
    function isTokenExpired(token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            const payload = JSON.parse(jsonPayload);
            const expiryTime = payload.exp * 1000; // Convert seconds to milliseconds
            const refreshThreshold = 2 * 60 * 1000; // 1 minutes before expiry
            return Date.now() >= expiryTime - refreshThreshold;
        } catch (error) {
            console.error("Error decoding JWT:", error);
            return true; // Assume expired if there's an error
        }
    }

    // Function to refresh the token
    async function refreshToken(refreshToken, clientId, tokenUrl) {
        const params = new URLSearchParams();
        params.append('grant_type', 'refresh_token');
        params.append('client_id', clientId);
        params.append('refresh_token', refreshToken);

        try {
            const response = await fetch(tokenUrl, { // Use the correct token endpoint URL
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: params.toString()
            });

            if (!response.ok) {
                throw new Error(`Token refresh failed: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            return data; // Should contain new access_token, etc.
        } catch (error) {
            console.error("Error refreshing token:", error);
            throw error;
        }
    }
    return (
        <AuthContext.Provider value={{ authToken, updateAuth, clearAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);